<template>
  <div>
    <titulo-produtos @cadastrar="openModal" />
    <filtro-produtos @filtro="setFiltro" @filtrar="getProdutos" />
    <tabela-produto
      :items="produtos"
      @editar="openModal"
      @atualiza-tabela="getProdutos"
      @alterar-ordenacao="novaOrdenacao"
    />
    <paginacao
      v-model="paginacao"
      :total="paginacao.total"
      @input="getProdutos"
    />
    <modal-produto
      :exibir="modais.produto"
      :dados="modais.produtoDados"
      @fechar="closeModal"
      @atualiza-tabela="getProdutos"
    />
  </div>
</template>
<script>
// Utils & Aux:
import breadcrumb from '@/common/utils/breadcrumb';
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import modais from '@/common/utils/modais';

// Services:
import ProdutosService from '@/common/services/produtos/produtos.service.js';

// Components:
import ModalProduto from './components/modal/Index';
import TabelaProduto from './components/Tabela';
import TituloProdutos from '@/views/suprimentos/produtos/components/TituloProdutos';
import Paginacao from '@/components/paginacao/Paginacao';
import FiltroProdutos from './components/Filtro';
export default {
  components: {
    TabelaProduto,
    ModalProduto,
    TituloProdutos,
    FiltroProdutos,
    Paginacao,
  },
  data() {
    return {
      produtos: [],
      modais: {
        produto: false,
        produtoDados: {},
      },
      filtro: {
        descricao: '',
      },
      paginacao: {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
        total: 0,
      },
      campoOrdenado: null,
      ordem: false,
    };
  },
  mounted() {
    breadcrumb.definir(this.$store, [
      { titulo: 'SUPRIMENTOS.SUPRIMENTOS' },
      { titulo: 'SUPRIMENTOS.PRODUTOS' },
    ]);
    this.getProdutos();
  },
  methods: {
    // FUNÇÕES OBTENÇÃO DE DADOS:
    getProdutos() {
      this.$store.dispatch(START_LOADING);

      let param = {
        NumeroDaPagina: this.paginacao.numeroDaPagina,
        TamanhoDaPagina: this.paginacao.tamanhoDaPagina,
        CampoOrdenado :this.campoOrdenado, 
        OrdenacaoAscendente:this.ordem,
        expressao: this.filtro.descricao
      }
      ProdutosService.obterPorExpressaoPaginado(param)
        .then(({ data }) => {
          this.produtos = data.itens;
          this.paginacao.total = data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    setFiltro(value) {
      this.filtro = value;
    },
    // FUNÇÕES MODAL:
    openModal(key, item) {
      return modais.abrirModal(this, key, item);
    },
    closeModal(key) {
      return modais.fecharModal(this, key);
    },
    
    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = !ordem;
      this.getProdutos(); 
    },
  },
};
</script>
